import { inject } from 'mobx-react'

type InjectableStore = 'Home' | 'Infra' | 'Application' | 'MobileApplication' | 'Account' | 'Session' | 'User' | 'Payment' | 'ItemAdditions'
type WithoutInjectedStores<T> = Omit<T, InjectableStore>
type ComponentWithoutInjectedStores<Props> = (props: WithoutInjectedStores<Props>) => JSX.Element

export const injectStores = (...stores: InjectableStore[]) => <T>(component: (props: T) => JSX.Element) => inject(...stores)(component) as unknown as ComponentWithoutInjectedStores<T>
